// extracted by mini-css-extract-plugin
export var content = "ContentCard-module--content--1Um9X";
export var contentTitle = "ContentCard-module--contentTitle--uLvxs";
export var contentBody = "ContentCard-module--contentBody--1tGVs";